import { getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reduceOverridableErrors } from '../../actions/policy/reduceOverridableErrors';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getOverridableErrorsSaga() {
    try {
        yield put(reduceLoading({ code: 'getOverridableErrors', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/policyTransaction/overridable-errors/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        yield put(reduceOverridableErrors(result.overridableErrors || []));
    } catch (error) {
        console.log('Error while calling Get Overridable Errors API - ', error);
        yield put(reduceOverridableErrors([]));
    } finally {
        yield put(reduceLoading({ code: 'getOverridableErrors', value: false }));
    }
}
